<div
  #anchor
  class="bell-anchor"
  [class.is-sidebar]="placement() === 'sidebar'"
  [class.is-collapsed]="collapsed()"
  [class.is-open]="isOpen()"
  [attr.title]="collapsed() ? ariaLabel() : null"
>
  @if (collapsed()) {
  <!-- Compact: icon-only with overlaid counts -->
  <app-button
    variant="ghost"
    [iconOnly]="true"
    [icon]="needs() > 0 ? 'bell-ring' : 'bell'"
    class="bell-btn"
    [class.hv-bell-ring]="bellRinging()"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-expanded]="isOpen()"
    aria-haspopup="dialog"
    (click)="toggle()"
  />
  @if (needs() > 0) {
  <span class="dot-badge dot-needs" [class.is-critical]="hasCritical()" [class.hv-pop]="bellRinging()" aria-hidden="true">{{ fmt(needs()) }}</span>
  } @else if (unread() > 0) {
  <span class="dot-badge dot-unread" [class.hv-pop]="bellRinging()" aria-hidden="true">{{ fmt(unread()) }}</span>
  }
  } @else {
  <app-button
    variant="ghost"
    class="bell-btn"
    [class.w-full]="placement() === 'sidebar'"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-expanded]="isOpen()"
    aria-haspopup="dialog"
    (click)="toggle()"
  >
    <span class="bell-content">
      <span class="inline-flex items-center gap-2">
        <lucide-icon
          [name]="needs() > 0 ? 'bell-ring' : 'bell'"
          [size]="16"
          class="inline-flex shrink-0"
          [class.hv-bell-ring]="bellRinging()"
        ></lucide-icon>
        @if (placement() === 'sidebar') {
        <span class="bell-label">Notifications</span>
        }
      </span>
      @if (unread() > 0 || needs() > 0) {
      <span class="bell-counts">
        @if (unread() > 0) {
        <span class="count-unread" [class.hv-pop]="bellRinging()" aria-hidden="true">{{ fmt(unread()) }}</span>
        }
        @if (unread() > 0 && needs() > 0) {
        <span class="count-sep" aria-hidden="true">·</span>
        }
        @if (needs() > 0) {
        <span class="count-needs" [class.is-critical]="hasCritical()" [class.hv-pop]="bellRinging()" aria-hidden="true">
          <lucide-icon name="triangle-alert" [size]="11"></lucide-icon>{{ fmt(needs()) }}
        </span>
        }
      </span>
      }
    </span>
  </app-button>
  }
</div>

<ng-template #panelTpl>
  <app-notification-panel [mobile]="isMobile()" (closed)="close()" />
</ng-template>
